const STATE_KEY = 'dealerAppraisal.state'
const RESULT_KEY = 'dealerAppraisal.result'
const FLOW_KEY = 'dealerAppraisal.flow'

function isClient() {
  return typeof window !== 'undefined' && typeof localStorage !== 'undefined'
}

function readJson(key, fallback) {
  if (!isClient()) return fallback
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return fallback
    return JSON.parse(raw)
  } catch (_error) {
    return fallback
  }
}

function writeJson(key, value) {
  if (!isClient()) return
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (_error) {
    // ignore storage write errors
  }
}

export function getDealerAppraisalState() {
  const state = readJson(STATE_KEY, {})
  return {
    selectedBranch: state?.selectedBranch || null,
    selectedDate: state?.selectedDate || ''
  }
}

export function setDealerSelectedBranch(branch) {
  const current = getDealerAppraisalState()
  writeJson(STATE_KEY, {
    ...current,
    selectedBranch: branch || null
  })
}

export function setDealerSelectedDate(selectedDate) {
  const current = getDealerAppraisalState()
  writeJson(STATE_KEY, {
    ...current,
    selectedDate: selectedDate || ''
  })
}

export function setDealerBookingResult(result) {
  writeJson(RESULT_KEY, result || null)
}

export function getDealerBookingResult() {
  return readJson(RESULT_KEY, null)
}

export function clearDealerBookingResult() {
  if (!isClient()) return
  localStorage.removeItem(RESULT_KEY)
}

export function clearDealerAppraisalSession() {
  if (!isClient()) return
  localStorage.removeItem(STATE_KEY)
  localStorage.removeItem(RESULT_KEY)
  localStorage.removeItem(FLOW_KEY)
}

export function startDealerAppraisalFlow() {
  if (!isClient()) return
  clearDealerAppraisalSession()
  localStorage.setItem(FLOW_KEY, '1')
}

export function hasDealerAppraisalFlow() {
  if (!isClient()) return false
  return localStorage.getItem(FLOW_KEY) === '1'
}

export function endDealerAppraisalFlow() {
  clearDealerAppraisalSession()
}
